import * as yup from 'yup';

export const bookingFormPageSchema = yup
	.object({
		hideBranding: yup.boolean().default(false),
	})
	.default({});
